var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.375C5.70625 1.375 1.375 5.70625 1.375 11C1.375 16.2937 5.70625 20.625 11 20.625C16.2937 20.625 20.625 16.2937 20.625 11C20.625 5.70625 16.2937 1.375 11 1.375ZM10.2437 5.5H11.7563V13.0625H10.2437V5.5ZM11 17.1875C10.45 17.1875 9.96875 16.7063 9.96875 16.1562C9.96875 15.6062 10.45 15.125 11 15.125C11.55 15.125 12.0312 15.6062 12.0312 16.1562C12.0312 16.7063 11.55 17.1875 11 17.1875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExclamationMark);
export default __webpack_public_path__ + "static/media/ic-exclamation-mark.a81854b5aa56d965674ade311fa8a542.svg";
export { ForwardRef as ReactComponent };